import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || '');

export async function redirectToCheckout(items: { id: string; quantity: number; price: number }[], shippingAddress: string, phoneNumber: string, totalAmount: number) {
    const stripe = await stripePromise;

    const response = await fetch('/api/checkout', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.token}`,

        },
        body: JSON.stringify({ items, shippingAddress, phoneNumber, totalAmount }),
    });

    const { sessionId } = await response.json();

    if (sessionId) {
        await stripe?.redirectToCheckout({ sessionId });

    } else {
        throw new Error('No se pudo crear la sesión de pago');
    }
}
export default redirectToCheckout
